<!--考试-->
<template>
    <div class="el-Examination">
        <el-row class="page_content" v-show="laodShow">
            <h1 class="head_title_white">
                <el-row>
                    <el-col :span="12" :title="examName || ''">
                        <span class="limit_line_one">{{ examName || "" }}</span>
                    </el-col>
                    <el-col :span="12">
                        <span class="djs">考试剩余时间：{{ showTime }}</span>
                        <el-button type="primary" :disabled="disabledOk" style="float: right;"
                            :loading="handexamLoading" @click="handexam">提 交
                        </el-button>
                    </el-col>
                </el-row>

            </h1>
            <div class="bg_"></div>
            <el-row>
                <el-container>
                    <el-aside width="380px">
                        <fieldset class="stuInfo">
                            <legend>考生信息</legend>
                            <img :src="rzImg" style="width:100px;height:100px;" />
                            <p>姓名：{{ studentInfo.studentName }}</p>
                            <p>学号：{{ studentInfo.studentNo }}</p>
                        </fieldset>
                        <el-row class="dtk_all">
                            <el-row style="background-color: rgb(227 234 246);padding: 10px;margin-bottom:10px;">
                                <span style="color:#409EFF;margin-right:10px;font-weight: 700;">答题卡</span>
                                <span style="color:#e6a23c;">{{ numberTopics }} / {{ examInfo.length }}</span>
                                <span style="float:right;">
                                    <span
                                        style="background-color: white;padding: 3px 12px;margin-right:10px;"></span>未答题
                                    <span style="background-color: #67c23a;padding: 3px 12px;margin:0 10px;"></span>已答题
                                </span>
                            </el-row>
                            <template v-for='(item, index) in questionMap'>
                                <el-row class="dtk_h" :key="'title' + index">
                                    {{ index }}
                                </el-row>
                                <el-row style="padding: 10px;">
                                    <ul>
                                        <template v-for='(it, ind) in item.list'>
                                            <li :class="answerOrNot(it)" :key="ind + '_c'"
                                                @click="jump(it.examQuestionId)">
                                                {{ Number(item.num) - Number(item.list.length) + ind + 1 }}
                                            </li>
                                        </template>
                                    </ul>
                                </el-row>
                            </template>
                        </el-row>
                    </el-aside>
                    <el-main>
                        <el-row class="all_subject">
                            <template v-for='(item, index) in examInfo'>
                                <template
                                    v-if="index == 0 || (examInfo[index - 1].examQuestionTypeName != examInfo[index].examQuestionTypeName)">
                                    <h1>{{ item.examQuestionTypeName }}</h1>
                                </template>
                                <template v-if="item.examQuestionTypeConcat == 1">
                                    <el-row :key="index" :class="'jump' + item.examQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                v-html="$imgHtml(item.examQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <ul>
                                                    <el-radio-group :disabled="disabledOk"
                                                        v-model="radio[item.examQuestionId]"
                                                        @change="radioChange(item.examQuestionId)">
                                                        <li v-for="(it, inde) in item.examQuestionOptionList">
                                                            <el-radio :label="it.examQuestionOptionOptionSign">
                                                                <el-row style="float: left;"
                                                                    v-html="it.examQuestionOptionOptionSign + '、'"></el-row>
                                                                <el-row style="float: left;"
                                                                    v-html="$imgHtml(it.examQuestionOptionOptionContent)"></el-row>
                                                            </el-radio>
                                                        </li>
                                                    </el-radio-group>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </template>

                                <template v-if="item.examQuestionTypeConcat == 2">
                                    <el-row :key="index" :class="'jump' + item.examQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                v-html="$imgHtml(item.examQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <ul>
                                                    <el-checkbox-group :disabled="disabledOk"
                                                        v-model="checkbox[item.examQuestionId]"
                                                        @change="checkboxChange(item.examQuestionId)">
                                                        <li v-for="(it, inde) in item.examQuestionOptionList">
                                                            <el-checkbox :label="it.examQuestionOptionOptionSign">
                                                                <el-row style="float: left;"
                                                                    v-html="it.examQuestionOptionOptionSign + '、'"></el-row>
                                                                <el-row style="float: left;"
                                                                    v-html="$imgHtml(it.examQuestionOptionOptionContent)"></el-row>
                                                            </el-checkbox>
                                                        </li>
                                                    </el-checkbox-group>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </template>

                                <template v-if="item.examQuestionTypeConcat == 3">
                                    <el-row :key="index" :class="'jump' + item.examQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                v-html="$imgHtml(item.examQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <ul>
                                                    <el-radio-group :disabled="disabledOk"
                                                        v-model="judgeQuestion[item.examQuestionId]"
                                                        @change="judgeQuestionChange(item.examQuestionId)">
                                                        <li>
                                                            <el-radio label="对">对</el-radio>
                                                        </li>
                                                        <li>
                                                            <el-radio label="错">错</el-radio>
                                                        </li>
                                                    </el-radio-group>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </template>

                                <template v-if="item.examQuestionTypeConcat == 4">
                                    <el-row :key="index" :class="'jump' + item.examQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                v-html="$imgHtml(item.examQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-input :disabled="disabledOk"
                                                    @blur="shortAnswerBlur(item.examQuestionId)" :rows="3"
                                                    type="textarea" style="margin:10px 0;"
                                                    v-model="shortAnswer[item.examQuestionId]"></el-input>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                    <el-row style="min-height: 160px;">
                                        <el-upload :disabled="disabledOk" :action="uploadUrl" :headers="headers"
                                            list-type="picture-card" :before-upload="beforeAvatarUpload"
                                            accept=".png,.jpg" :file-list="shortAnswerImgs[item.examQuestionId]"
                                            :on-preview="handlePictureCardPreview"
                                            :on-success="(res, file) => { attributeSuccess(item, res, file) }"
                                            :on-remove="(file, fileList) => { handleRemove(item, fileList) }">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-row>
                                </template>
                            </template>
                        </el-row>
                    </el-main>
                </el-container>
            </el-row>
        </el-row>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <!--        <face-recognition v-if="recognitionShow" :faceRecognition="faceRecognition" :collectionType="collectionType"-->
        <!--                          :verificationTimes="verificationTimes"-->
        <!--                          :studentPhotoUrl="studentPhotoUrl"-->
        <!--                          pageName="examInfoPage" :key="timer"></face-recognition>-->
        <face-recognition ref="faceRecognitionRef" v-show="visibleFaceModal" :visible="visibleFaceModal"
            :intervalTime="getCurrentFaceConfig.intervalTime" :skip="getCurrentFaceConfig.skip"
            :score="getCurrentFaceConfig.score" :photoCount="getCurrentFaceConfig.photoCount" :faceNumber="faceNumber"
            @faceOver="faceRecord" @onSkip="onSkipRecord" @notCertified="backOff"
            @stopNavigator="faceRecognitionByStop" />
    </div>
</template>
<script>
import { getCookieForRoleTag } from "../../../common/ulit";
import rzImg from '@/images/user/rz.png';
// import faceRecognition from "@/components/faceRecognition";	//人脸识别
import faceRecognition from "@/components/faceRecognition_K";	//人脸识别
import $ from 'jquery';
import { getStorageKeyForRoleTag, getStudentInfoKeyForRoleTag, getUserIP } from "../../../common/ulit";

export default {
    name: "Examination",
    components: {
        faceRecognition
    },
    data() {
        return {
            numberTopics: 0,
            studentInfo: JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())),
            examId: this.$route.query.examId,
            examName: this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag('examName_examination'))) ? "考试信息" : localStorage.getItem(getStorageKeyForRoleTag('examName_examination')),
            examStudentId: this.$route.query.examStudentId,
            examInfo: [],
            examStudentInfoList: [],
            radio: {}, //单选题答案
            checkbox: {},//多选题答案
            judgeQuestion: {},//判断题
            shortAnswer: {},//简答题
            questionMap: {},//所有题目map("题目类型：{list:[],mum")
            rzImg: rzImg,
            timer: '',
            url: "", //用于判断是继续考试还是开始考试
            examTimeLimit: 0,//考试总时间（分钟）
            showTime: "00 分钟 00 秒", //显示的时间倒计时
            disabledOk: false,
            recognitionShow: false, //加载完成后显示组件
            laodShow: true, //加载完成后显示整个页面
            faceRecognition: 1, //是否开启人脸 1是 2否
            collectionType: 1, //采集方式 1不可关闭 2可关闭
            verificationTimes: 10, //验证次数
            studentPhotoUrl: "", //照片地址，优先判断照片地址，如果没有则提示去上传学籍照片等待审核
            getNowTime: null,
            handexamLoading: false,
            answerMap: {}, //用于存储学生所选答案，存入一定数量或者是交卷的时候一起提交后台：结构{题目ID：{答案信息}}
            sutdentAllAnswerMap: {}, //学生所有已答答案 结构{题目ID：{答案信息}}交卷时会重新提交全部答案。
            onExamQuestionId: null,//存储上次点击的题目ID，主要用于多选题时，打完本题后再提交数据
            //===========K=>
            ip: undefined,//当前登录用户的IP
            visibleFaceModal: false,//控制人脸识别弹框是否显示
            tePlanCourseId: this.$route.query.tePlanCourseId,
            timer_intervalFaceCheck: null,//间隔调起人脸，定时器
            faceNumber: 0,//人脸识别次数
            //<=K===========

            //上传
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            dialogImageUrl: '',
            dialogVisible: false,
            shortAnswerImgs: {}, //用于存简答题图片路径
            examStudentAddTime: null, // 缓存考试开始时间
            examTimeLimitCache: null, // 缓存考试时长
            timerStarted: false, // 防止多次启动倒计时
        };
    },
    computed: {
        getCurrSemesterBySession() {
            //主页面【在线学习】中当前学期对应的一些信息
            let data = sessionStorage.getItem(getStudentInfoKeyForRoleTag() + "_onlineLearningRows");
            return JSON.parse(data);//[]
        },
        getAllSemesterBySession() {
            //主页面【在线学习】中所有学期对应的一些信息
            let allData = sessionStorage.getItem(getStudentInfoKeyForRoleTag() + "_onlineLearningAllRows");
            return JSON.parse(allData);
        },
        getSessionInfoByLearning() {
            //从本地缓存中提取关键信息，grade、semesters
            const arr = this.getCurrSemesterBySession;
            const allArr = this.getAllSemesterBySession;
            let obj = {};
            if (Array.isArray(arr) && arr.length > 0) {
                obj = arr[0]
            } else if (Array.isArray(allArr) && allArr.length > 0) {
                obj = allArr[0];
            }
            return obj;
        },
        currentPageIsBK() {
            // 判断当前是否为补考页面
            const pageType = this.$route.query.pageType;
            return pageType && pageType === 'bk';
        },
        getStudentInfoByLocal() {
            return JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())) || {};
        },
        getStudentId() {
            return this.getStudentInfoByLocal.studentId;
        },
        getCurrentCourse() {
            //当前课程
            return this.tePlanCourseId;
        },
        getFaceRecognitionSetting() {
            return this.$store.getters['faceRecognition/getAll']
        },
        getCurrentFaceConfig() {
            //当前课程对应的权限
            const allAuth = this.getFaceRecognitionSetting;
            if (!Array.isArray(allAuth)) {
                return null;
            }
            const obj = allAuth.find(item => item.courseId === this.getCurrentCourse) || {};
            const {
                courseFaceSwitch,
                //考试相关配置
                examPhotoIntervalTime,
                examSkipTimes,
                examFaceScore,
                examPhotoCount,
                examinationInstate,
                examinationOutstate,
                //补考相关配置
                makeupExamPhotoIntervalTime,
                makeupExamSkipTimes,
                makeupExamFaceScore,
                makeupExamPhotoCount,
                resitInstate,
                resitOutstate
            } = obj;
            console.log("当前课程对应权限", obj);
            const config = !this.currentPageIsBK ? {
                faceSwitch: courseFaceSwitch,//是否需要开启
                in: examinationInstate,
                out: examinationOutstate,
                intervalTime: examPhotoIntervalTime,
                skip: examSkipTimes,
                score: examFaceScore,
                photoCount: examPhotoCount,
            } : {
                faceSwitch: courseFaceSwitch,//是否需要开启
                in: resitInstate,
                out: resitOutstate,
                intervalTime: makeupExamPhotoIntervalTime,
                skip: makeupExamSkipTimes,
                score: makeupExamFaceScore,
                photoCount: makeupExamPhotoCount,
            }
            config.studentPhotoUrl = this.studentPhotoUrl;
            console.log("当前是否为补考？", this.currentPageIsBK);
            console.log("当前配置为：", config);
            return config;
        },
    },

    created() {
        this.isrlsb()
        if (this.$isEmpty(this.examId) && this.$isEmpty(this.examStudentId)) {
            this.$message({
                message: "课程数据丢失，请返回上一页！",
                type: 'warning'
            });
        }
    },
    mounted() {
        getUserIP((ip) => {
            //获取当前登录用户的IP地址
            this.ip = ip;
        })
    },
    methods: {
        attributeSuccess(item, res, file) { //上传成功回调
            if (this.shortAnswerImgs[item.examQuestionId] == null || this.shortAnswerImgs[item.examQuestionId] == "") {
                this.shortAnswerImgs[item.examQuestionId] = [];
            }
            // this.headImg = this.$baseUrl + res.data.url;
            this.shortAnswerImgs[item.examQuestionId].push({
                name: res.data.nameFormat,
                url: this.$baseUrl + res.data.url,
                imgUrl: res.data.url
            }); //写入map
            this.shortAnswerImgs = Object.assign({}, this.shortAnswerImgs);
            this.shortAnswerBlur(item.examQuestionId);
        },
        handleRemove(item, fileList) {
            this.shortAnswerImgs[item.examQuestionId] = [];
            for (let key in fileList) {
                this.shortAnswerImgs[item.examQuestionId].push(fileList[key]); //写入map
            }
            this.shortAnswerBlur(item.examQuestionId);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 <= 10;

            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
            }
            if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return (isJPG || isPNG) && isLt5M;
        },
        faceRecognitionByStop(type) {
            //如果用户主动取消识别。那么关闭页面
            type !== undefined && this.backOff();
        },
        faceRecord(validateBool, imgPath, skip) {
            // 人脸识别成功
            if (validateBool === 1 || validateBool === '1') {
                this.visibleFaceModal = false;
                if (this.timer_intervalFaceCheck) {
                    clearInterval(this.timer_intervalFaceCheck);
                    this.timer_intervalFaceCheck = null;
                }
                // 识别成功后考试流程
                if (!this.getNowTime) {
                    this.getNowDate();
                }
            } else {
                // 人脸识别失败
                this.faceNumber++;
                if (this.faceNumber >= (this.getCurrentFaceConfig.skip || 1)) {
                    // 达到最大失败次数，直接跳过人脸识别，执行考试流程
                    this.visibleFaceModal = false;
                    if (this.timer_intervalFaceCheck) {
                        clearInterval(this.timer_intervalFaceCheck);
                        this.timer_intervalFaceCheck = null;
                    }
                    if (!this.getNowTime) {
                        this.getNowDate();
                    }
                } else {
                    // 还未达到最大失败次数，继续弹窗
                    this.$nextTick(() => {
                        this.$refs.faceRecognitionRef.initData(this.faceNumber);
                    });
                }
            }
            const { grade, semesters } = this.getSessionInfoByLearning || {};
            const msg = (this.currentPageIsBK ? '补考' : "期末考试") + ":" + this.examName;
            const params_record = {
                studentId: this.getStudentId,
                courseId: this.getCurrentCourse,
                photoType: "3",
                photoUrl: imgPath,
                ipAddress: this.ip,
                faceResult: validateBool,
                belongsProject: msg,//所属项目（xxx课件学习，xxx考试等信息）
                grade,
                semesters
            };
            this.$store.dispatch('user/face_record', params_record);
        },
        onSkipRecord() {
            this.visibleFaceModal = false;
            this.faceNumber++;
            if (this.faceNumber >= (this.getCurrentFaceConfig.skip || 1)) {
                clearInterval(this.timer_intervalFaceCheck);
                this.timer_intervalFaceCheck = null;
            }
            if (!this.getNowTime) {
                this.getNowDate();
            }
        },
        handleLoad() { //用于重载人脸识别组件
            this.timer = new Date().getTime()
        },
        backOff() {
            this.$closeWin();
        },
        radioChange(examQuestionId) { //单选题选择
            this.onExamQuestionId = examQuestionId;
            let param = {
                examQuestionId: examQuestionId,
                studentAnswer: this.radio[examQuestionId],
                examQuestionTypeConcat: 1 //展示方式(1单选 2多选 3判断 4简答)
            }
            //this.answerexam({examQuestionJsonStr:JSON.stringify(param)}); //原来的做一个题，提交一次

            this.sutdentAllAnswerMap[examQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId), JSON.stringify(this.sutdentAllAnswerMap));//根据examId存入答题缓存，交卷后注意删除

            this.answerMap[examQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
            if (Object.keys(this.answerMap).length >= 3) {
                this.answerexam();
            }
        },
        checkboxChange(examQuestionId) { //多选题选择
            let aa = this.checkbox[examQuestionId].sort((a, b) => { //按照abcd排序
                return a.localeCompare(b);
            });
            let param = {
                examQuestionId: examQuestionId,
                studentAnswer: aa.join(","),
                examQuestionTypeConcat: 2 //展示方式(1单选 2多选 3判断 4简答)
            }
            //如果上次点击的题目ID和本次操作的题目ID相同,则表示操作的是同一题目，则不提交数据到后台，只存入缓存
            if (this.$isEmpty(this.onExamQuestionId) || examQuestionId == this.onExamQuestionId) {
                this.sutdentAllAnswerMap[examQuestionId] = param; //现在先存入，再提交，
                localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId), JSON.stringify(this.sutdentAllAnswerMap));//根据examId存入答题缓存，交卷后注意删除

                this.answerMap[examQuestionId] = param; //现在先存入，再提交，
                localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
                this.onExamQuestionId = examQuestionId;
            } else { //操作的不是同一个题目，并且缓存中的数据大于等于3，那么就先提交之前的数据，再存入缓存
                this.onExamQuestionId = examQuestionId;
                if (Object.keys(this.answerMap).length >= 2) {
                    this.answerexam(null, param);
                } else {
                    this.sutdentAllAnswerMap[examQuestionId] = param; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId), JSON.stringify(this.sutdentAllAnswerMap));//根据examId存入答题缓存，交卷后注意删除

                    this.answerMap[examQuestionId] = param; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
                }
            }
            //this.answerexam({examQuestionJsonStr:JSON.stringify(param)});//原来的做一个题，提交一次
        },
        judgeQuestionChange(examQuestionId) { //判断题
            this.onExamQuestionId = examQuestionId;
            let param = {
                examQuestionId: examQuestionId,
                studentAnswer: this.judgeQuestion[examQuestionId],
                examQuestionTypeConcat: 3 //展示方式(1单选 2多选 3判断 4简答)
            }
            //this.answerexam({examQuestionJsonStr:JSON.stringify(param)});//原来的做一个题，提交一次

            this.sutdentAllAnswerMap[examQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId), JSON.stringify(this.sutdentAllAnswerMap));//根据examId存入答题缓存，交卷后注意删除

            this.answerMap[examQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
            if (Object.keys(this.answerMap).length >= 3) {
                this.answerexam();
            }
        },
        shortAnswerBlur(examQuestionId) { //简答题
            this.onExamQuestionId = examQuestionId;
            let imgsList = [];
            if (this.shortAnswerImgs[examQuestionId] != null && this.shortAnswerImgs[examQuestionId] != "") {
                for (let ind in this.shortAnswerImgs[examQuestionId]) {
                    imgsList.push(this.shortAnswerImgs[examQuestionId][ind].imgUrl)
                }
            }
            let param = {
                examQuestionId: examQuestionId,
                studentAnswer: this.shortAnswer[examQuestionId],
                studentAnswerImgs: imgsList.length > 0 ? JSON.stringify(imgsList) : "", //图片
                examQuestionTypeConcat: 4 //展示方式(1单选 2多选 3判断 4简答)
            }
            //this.answerexam({examQuestionJsonStr:JSON.stringify(param)});//原来的做一个题，提交一次

            this.sutdentAllAnswerMap[examQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId), JSON.stringify(this.sutdentAllAnswerMap));//根据examId存入答题缓存，交卷后注意删除

            this.answerMap[examQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
            // if(Object.keys(this.answerMap).length >= 3){
            //     this.answerexam();
            // }
            this.answerexam(); //简答题暂时先答一个 提交一个
        },
        handleOpen(key, keyPath) { },
        handleClose(key, keyPath) { },
        //获取考试信息
        getExamInfo(param) {
            const loading = this.$loading({
                lock: true,
                text: '加载考试信息中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch(this.url, param).then((ret) => {
                if (ret.code === 0 || ret.code === '0') {
                    this.recognitionShow = true;
                    this.faceRecognition = ret.faceRecognitionInfo.faceRecognition; //是否开启人脸 1是 2否
                    this.collectionType = ret.faceRecognitionInfo.collectionType; //采集方式 1不可关闭 2可关闭
                    this.verificationTimes = ret.faceRecognitionInfo.verificationTimes; //验证次数
                    this.studentPhotoUrl = ret.faceRecognitionInfo.studentPhotoUrl; //照片地址，优先判断照片地址，如果没有则提示去上传学籍照片等待审核
                    if (!this.$isEmpty(ret.data.ExamQuestionList)) {
                        let num = 0;
                        let list = 0;

                        //获取所有缓存中已答题目答案
                        let sutdentAllAnswerMap = localStorage.getItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId)); //获取之前未提交的题目答案信息
                        this.sutdentAllAnswerMap = !this.$isEmpty(sutdentAllAnswerMap) ? JSON.parse(sutdentAllAnswerMap) : {};

                        //如果缓存中存在数据，则返显回去，如果缓存中的答案与后台的冲突，以前台数据为准

                        ret.data.ExamQuestionList.forEach((element, i) => {
                            let stuAnswer = null;
                            if (Object.keys(this.sutdentAllAnswerMap).length > 0 && !this.$isEmpty(this.sutdentAllAnswerMap[element.examQuestionId])) {
                                stuAnswer = this.sutdentAllAnswerMap[element.examQuestionId].studentAnswer; //缓存中的学生答案
                            }
                            if (element.examQuestionTypeConcat == 1) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.radio[element.examQuestionId] = stuAnswer;
                                } else {
                                    this.radio[element.examQuestionId] = element.studentAnswer;
                                }
                            } else if (element.examQuestionTypeConcat == 2) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.checkbox[element.examQuestionId] = stuAnswer.split(",");
                                } else {
                                    if (!this.$isEmpty(element.studentAnswer)) {
                                        this.checkbox[element.examQuestionId] = element.studentAnswer.split(",");
                                    } else {
                                        this.checkbox[element.examQuestionId] = [];
                                    }
                                }
                            } else if (element.examQuestionTypeConcat == 3) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.judgeQuestion[element.examQuestionId] = stuAnswer;
                                } else {
                                    this.judgeQuestion[element.examQuestionId] = element.studentAnswer;
                                }
                            } else if (element.examQuestionTypeConcat == 4) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.shortAnswer[element.examQuestionId] = stuAnswer;
                                } else {
                                    this.shortAnswer[element.examQuestionId] = element.studentAnswer;
                                }

                                let studentAnswerImgs = [];
                                if (Object.keys(this.sutdentAllAnswerMap).length > 0 && !this.$isEmpty(this.sutdentAllAnswerMap[element.examQuestionId])) {
                                    if (this.sutdentAllAnswerMap[element.examQuestionId].studentAnswerImgs != null && this.sutdentAllAnswerMap[element.examQuestionId].studentAnswerImgs != "") {
                                        let imgsList = JSON.parse(this.sutdentAllAnswerMap[element.examQuestionId].studentAnswerImgs); //缓存中的学生答案
                                        for (let ind in imgsList) {
                                            studentAnswerImgs.push({
                                                name: "",
                                                url: this.$baseUrl + imgsList[ind],
                                                imgUrl: imgsList[ind]
                                            })
                                        }
                                    } else {
                                        if (element.studentAnswerImgs != null && element.studentAnswerImgs != "") {
                                            let imgsList = JSON.parse(element.studentAnswerImgs); //缓存中的学生答案
                                            for (let ind in imgsList) {
                                                studentAnswerImgs.push({
                                                    name: "",
                                                    url: this.$baseUrl + imgsList[ind],
                                                    imgUrl: imgsList[ind]
                                                })
                                            }
                                        }
                                    }
                                } else {
                                    if (element.studentAnswerImgs != null && element.studentAnswerImgs != "") {
                                        let imgsList = JSON.parse(element.studentAnswerImgs); //缓存中的学生答案
                                        for (let ind in imgsList) {
                                            studentAnswerImgs.push({
                                                name: "",
                                                url: this.$baseUrl + imgsList[ind],
                                                imgUrl: imgsList[ind]
                                            })
                                        }
                                    }
                                }
                                this.shortAnswerImgs[element.examQuestionId] = studentAnswerImgs;
                            }
                            //如果本地答案为空，后台答案不为空，那么将后台数据写入缓存中去
                            if (this.$isEmpty(stuAnswer) && !this.$isEmpty(element.studentAnswer)) {
                                this.sutdentAllAnswerMap[element.examQuestionId] = {
                                    examQuestionId: element.examQuestionId,
                                    studentAnswer: element.studentAnswer,
                                    examQuestionTypeConcat: element.examQuestionTypeConcat //展示方式(1单选 2多选 3判断 4简答)
                                };
                            }

                            if (this.$isEmpty(this.questionMap[element.examQuestionTypeName])) {
                                this.questionMap[element.examQuestionTypeName] = {
                                    list: [],
                                    num: 0
                                };
                            }
                            num = num + 1;
                            this.questionMap[element.examQuestionTypeName].list.push(element);
                            this.questionMap[element.examQuestionTypeName].num = num;
                        });

                        this.radio = Object.assign({}, this.radio);
                        this.checkbox = Object.assign({}, this.checkbox);
                        this.judgeQuestion = Object.assign({}, this.judgeQuestion);
                        this.shortAnswer = Object.assign({}, this.shortAnswer);
                        this.shortAnswerImgs = Object.assign({}, this.shortAnswerImgs);

                        this.examInfo = ret.data.ExamQuestionList;
                        this.examStudentInfoList = ret.data.examStudentInfoList;
                        this.examStudentId = ret.data.examStudentId;
                        const tePlanCourseId = ret.data.tePlanCourseId;
                        this.tePlanCourseId = tePlanCourseId;
                        //需要间隔吊起人脸
                        const getCurrentFaceConfig = this.getCurrentFaceConfig;
                        const skip = getCurrentFaceConfig.skip || 1;
                        const interval = getCurrentFaceConfig.intervalTime ? getCurrentFaceConfig.intervalTime * 60 * 1000 : 0;
                        this.faceNumber = 0;
                        if (this.timer_intervalFaceCheck) clearInterval(this.timer_intervalFaceCheck);
                        if (skip > 0 && interval > 0) {
                            this.timer_intervalFaceCheck = setInterval(() => {
                                if (this.faceNumber < skip) {
                                    this.visibleFaceModal = true;
                                } else {
                                    clearInterval(this.timer_intervalFaceCheck);
                                    this.timer_intervalFaceCheck = null;
                                }
                            }, interval);
                        }
                        this.examStudentAddTime = ret.data.examStudentAddTime;
                        this.examTimeLimitCache = ret.examTimeLimit;
                        this.$forceUpdate();
                        //根据考试开始时间 和考试时长与当前时间对比 得到考试倒计时
                        this.timeInterval(ret.data.examStudentAddTime, ret.examTimeLimit); //加载考试倒计时
                    } else {
                        this.$message({
                            message: "题目数量为空！",
                            type: 'warning',
                            onClose: () => {
                                this.$closeWin();
                            }
                        });
                    }
                    loading.close();
                } else {
                    loading.close();
                    this.$message({
                        message: ret.msg,
                        type: 'warning',
                        onClose: () => {
                            this.$closeWin();
                        }
                    });
                }
            }).catch(() => {
                loading.close();
            });
        },
        answerexam(typeInfo, paramInfo) { //答题,提交答案 typeInfo == 1:表是交卷
            let param = [];
            if (typeInfo == 1) {
                for (let item in this.sutdentAllAnswerMap) { //转换成需要的格式
                    param.push(this.sutdentAllAnswerMap[item]);
                }
            } else {
                for (let item in this.answerMap) { //转换成需要的格式
                    param.push(this.answerMap[item]);
                }
                if (!this.$isEmpty(paramInfo)) {
                    this.sutdentAllAnswerMap[paramInfo.examQuestionId] = paramInfo; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId), JSON.stringify(this.sutdentAllAnswerMap));//根据examId存入答题缓存，交卷后注意删除

                    this.answerMap[paramInfo.examQuestionId] = paramInfo; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
                }
            }


            this.$store.dispatch("user/answerExam", { examQuestionJsonStr: JSON.stringify(param) }).then((ret) => {
                if (ret.code != 0 && ret.code != '0') {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                } else {
                    if (typeInfo == 1) { //typeInfo == 1:表是交卷，交卷的时候需要先提交一下答案，答案提交成功后再执行交卷操作
                        this.handexamLoading = false;
                        this.subHandExam();
                    } else {
                        //提交成功，根据已提交的数据examQuestionId，删除掉this.answerMap中存在的
                        for (let i = 0; i < param.length; i++) {
                            delete this.answerMap[param[i].examQuestionId]; //删除掉已经提交成功的，只剩下未提交成功的数据
                        }
                        localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.examId), JSON.stringify(this.answerMap));//根据examId存入答题缓存，交卷后注意删除
                    }
                }
            });
        },
        process_onLeaveFaceCheck() {
            return new Promise((resolve) => {
                // TODO:
                const { out } = this.getCurrentFaceConfig;
                if (out === 1) {
                    //交卷时需要根据配置进行人脸识别
                    this.visibleFaceModal = true;
                    this.$watch(() => this.visibleFaceModal, (val) => {
                        if (val === false) {
                            resolve(true);
                        }
                    })
                } else {
                    resolve(true);
                }
            })
        },
        async handexam() { //交卷
            await this.process_onLeaveFaceCheck();
            this.$confirm('是否确定提交试卷？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 手动交卷的时候，判断简答题是否答题，此处判断【必答后才能交卷】，包括手动答题及上传图片答题，
                for (let item in this.shortAnswer) { //转换成需要的格式
                    if (this.$isEmpty(this.sutdentAllAnswerMap[item])) { //根据题目ID获取学生答案map中的答案，如果为空
                        this.$message({ message: "简答题存在未作答题目，请先完成作答再提交！", type: 'warning' });
                        return;
                    } else if (this.$isEmpty(this.sutdentAllAnswerMap[item].studentAnswer) && this.$isEmpty(this.sutdentAllAnswerMap[item].studentAnswerImgs)) {
                        this.$message({ message: "简答题存在未作答题目，请先完成作答再提交！", type: 'warning' });
                        return;
                    }
                }
                //this.subHandExam();
                this.handexamLoading = true;
                this.answerexam(1); // 1:表是交卷，交卷的时候需要先提交一下答案，答案提交成功后再执行交卷操作
            }).catch(() => {

            });
        },
        jump(index) {
            let total = $(".jump" + index).position().top;
            let top = $(".all_subject").scrollTop(); //当前滚动条的高度
            $(".all_subject").animate({ scrollTop: top + total }, 1000);//1000是ms,也可以用slow代替
        },
        answerOrNot(obj) { //是否答题
            this.numberTop();
            if (obj.examQuestionTypeConcat == 1) {
                if (!this.$isEmpty(this.radio[obj.examQuestionId])) {
                    return "yd";
                }
                return "";
            } else if (obj.examQuestionTypeConcat == 2) {
                if (this.checkbox[obj.examQuestionId].length > 0) {
                    return "yd";
                }
                return "";
            } else if (obj.examQuestionTypeConcat == 3) {
                if (!this.$isEmpty(this.judgeQuestion[obj.examQuestionId])) {
                    return "yd";
                }
                return "";
            } else if (obj.examQuestionTypeConcat == 4) {
                if (!this.$isEmpty(this.shortAnswer[obj.examQuestionId]) || (this.shortAnswerImgs[obj.examQuestionId] != null && this.shortAnswerImgs[obj.examQuestionId] != "" && this.shortAnswerImgs[obj.examQuestionId].length > 0)) {
                    return "yd";
                }
                return "";
            }
        },
        numberTop() {
            let this_ = this;
            setTimeout(function () {
                this_.numberTopics = $(".yd").length;
            }, 100);
        },
        subHandExam() {
            this.$store.dispatch("user/handExam", { examStudentId: this.examStudentId }).then((ret) => {
                if (ret.code == 0 || ret.code == '0') {
                    localStorage.setItem(getStorageKeyForRoleTag('exam_tag'), 1);
                    localStorage.removeItem(getStorageKeyForRoleTag('answerMap_' + this.examId)); //交卷成功后删除答题缓存
                    localStorage.removeItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.examId)); //交卷成功后删除所有答题缓存
                    this.$message({
                        message: "交卷成功！" || "提交成功！",
                        type: 'success',
                        onClose: () => {
                            this.$closeWin();
                        }
                    });
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        timeInterval(examStudentAddTime, examTimeLimit) { //考试开始时间，时长分钟
            let endTime = Date.parse(examStudentAddTime) + (examTimeLimit * 60 * 1000); //考试开始时间 + 时长(分钟) = 考试结束时间；
            let _this = this;
            let second = (endTime - Date.parse(this.getNowTime)) / 1000; //(考试结束时间 -  当前时间) / 1000 = 相差秒数
            if (second <= 0) {
                this.disabledOk = true;
                setTimeout(() => {
                    _this.$loading({
                        lock: true,
                        text: '考试时间结束，自动交卷中......',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    _this.answerexam(1); // 1:表是交卷，交卷的时候需要先提交一下答案，答案提交成功后再执行交卷操作
                }, 100);
            } else {
                let setInt = setInterval(function () {
                    second = Number(second) - 1;
                    if (second <= 0) {
                        clearInterval(setInt);
                        _this.showTime = "00 分钟 00 秒";
                        _this.$alert('考试时间已结束，自动交卷中......', '系统提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                _this.$loading({
                                    lock: true,
                                    text: '考试时间结束，自动交卷中......',
                                    spinner: 'el-icon-loading',
                                    background: 'rgba(0, 0, 0, 0.7)'
                                });
                            }
                        });
                        _this.answerexam(1); // 1:表是交卷，交卷的时候需要先提交一下答案，答案提交成功后再执行交卷操作
                        //_this.subHandExam(); //自动交卷
                    } else {
                        let hour = Math.floor((second / 60 / 60) % 60), //分
                            min = Math.floor(hour * 60 + (second / 60) % 60), //分
                            sec = Math.floor(second % 60); //秒
                        if (min <= 9) {
                            min = "0" + min;
                        }
                        if (sec <= 9) {
                            sec = "0" + sec;
                        }
                        _this.showTime = min + " 分钟 " + sec + " 秒";
                        if (second == 60 || second == 600) {
                            _this.$message({
                                message: '距考试结束还有 ' + min + " 分钟！",
                                type: 'warning'
                            });
                        }
                    }
                }, 1000);
            }
        },
        isrlsb() {
            this.$store.dispatch('user/getFaceSetting', this.tePlanCourseId).then(res => {
                const { code, data } = res;
                if (code === 0 && data && data[0]) {
                    const faceConfig = data[0];//Object
                    this.$store.commit('faceRecognition/add', faceConfig);
                    const { resitInstate, examinationInstate } = faceConfig;//初始化时，补考/考试是否需要开启人脸识别
                    const init2In = this.currentPageIsBK ? resitInstate : examinationInstate;
                    this.visibleFaceModal = init2In;//初始化开启人脸识别

                    // 如果init2In为1，需要人脸识别，等人脸识别成功后再执行getNowDate
                    // 如果init2In不为1，直接执行getNowDate开始考试倒计时
                    if (init2In !== 1) {
                        this.getNowDate();
                    }
                } else {
                    // 没有faceConfig，直接执行getNowDate
                    this.getNowDate();
                }
            })
        },
        getNowDate() {
            const this_ = this;
            this.$store.dispatch("getNowTime").then((res) => {
                if (res.code == 0) {
                    this.getNowTime = res.data;
                    if (!this.$isEmpty(this.examId)) {
                        const param = {
                            examId: this.examId
                        }
                        this.url = "user/getExamInfo";
                        this.getExamInfo(param);
                    }
                    if (!this.$isEmpty(this.examStudentId)) {
                        const param = {
                            examStudentId: this.examStudentId
                        }
                        this.url = "user/getexamStudentInfo";
                        this.getExamInfo(param);
                    }
                } else {
                    this.$message({
                        message: "获取系统时间错误！",
                        type: 'warning',
                        onClose: () => {
                            this.$closeWin();
                        },
                    })
                }
            }).catch(() => {
                this.$message({
                    message: "获取系统时间错误！",
                    type: 'warning',
                    onClose: () => {
                        this.$closeWin();
                    },
                })
            });
        }
    }
};
</script>
<style lang="less">
@import '../../../styles/base.less';

.el-Examination {
    .head_title_white {
        color: #000000;
        margin-bottom: 0;

        .djs {
            float: right;
            min-width: 260px;
            font-weight: 100;
            font-size: 17px;
            line-height: 40px;
            margin-left: 10px;
        }
    }

    .head_title {
        margin: 0;
        font-size: 20px;
        margin-right: -20px;
    }

    .bg_ {
        background-color: white;
        margin: 0 -20px;
        border-bottom: 1px solid #f3f3f3;
        margin-bottom: 10px;
    }

    .yd {
        background-color: #67c23a;
        color: #FFFFFF;
    }

    .el-dialog {
        border-radius: 10px;
    }

    .el-main {
        background-color: white;
        padding: 0 20px !important;
        border: 1px solid #e3eaf6;
        margin-left: 10px;
        border-radius: 5px;
        margin-top: 10px;
    }

    .el-menu-vertical-demo {
        height: calc(100vh - 375px);
        min-height: 500px;
        overflow: auto;
        border: solid 1px #e6e6e6;
        border-top: none;
    }

    .page_content {
        height: calc(100vh - 40px);
    }

    //考生信息
    .stuInfo {
        border: 1px solid @primary_b;
        border-radius: 5px;
    }

    .el-aside {
        .dtk_all {
            border: 1px solid rgb(227 234 246);
            margin-top: 10px;
            height: calc(100vh - 380px);
            overflow: auto;
        }

        .dtk_all::-webkit-scrollbar {
            display: none;
        }

        .dtk_h {
            background-color: #f3f3f3;
            padding: 10px;
            margin: 0 10px;
            font-weight: 700;
            border-left: 3px solid #409EFF;
        }

        ul {
            margin: 0;
            padding: 0;
            margin-right: 5px;
        }

        li {
            list-style-type: none;
            float: left;
            border: 1px solid #f3f3f3;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            margin-left: 3px;
            margin-bottom: 3px;
            cursor: pointer;
        }
    }

    .stem {
        font-size: 18px;
    }

    .all_subject {
        height: calc(100vh - 150px);
        overflow: auto;

        p {
            margin: 0;
            padding: 0;
        }

        ul li {
            list-style-type: none;
            line-height: 30px;

            .el-radio__label,
            .el-checkbox__label {
                font-size: 18px;
            }

        }
    }

    .all_subject::-webkit-scrollbar {
        display: none;
    }

    .el-radio__input,
    .el-radio__label,
    .el-checkbox__input,
    .el-checkbox__label {
        float: left;
    }

    .el-radio__inner,
    .el-checkbox__inner {
        margin-top: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/exam/Examination.vue